import { SingleResponse, CustomerApplicationProduct, CustomerResponse, Vendor } from "common";


export const mockCustomerResponse: SingleResponse<CustomerResponse[]> = {
    total: 1,
    result: [
        {
            "id": 70193,
            "consolidateDebitOrders": false,
            "contactMethod": 0,
            "individualId": 4709,
            "underReview": false,
            "individual": {
                "id": 4709,
                "birthDate": new Date("1979-10-17T00:00:00"),
                "firstName": "Aharon Dovid",
                "name": "Aharon Dovid",
                "gender": 1,
                "lastName": "Lis",
                "initials": "A.D.",
                "maritalStatus": 0,
                "title": 1,
                "individualIdentities": [
                    {
                        "id": 37422,
                        "identityType": 1,
                        "individualId": 4709,
                        "number": "7910175258089"
                    }
                ]
            },
            "customerInfo": {
                "isIndividual": true,
                "activeProduct": false,
                "id": 70193,
                "initials": "A.D.",
                "customerName": "Aharon Dovid Lis",
                "name": "Aharon Dovid",
                "lastName": "Lis",
                "customerAddress": "17 CHELTONDALE COURT\nCNR DOVEDALE & CHELTONDALE mailto:avenue\ncheltondale\n2192",
                "customeremail": "aharon@enationnetworks.co.za",
                "customerHome": "+27 73 675 7529",
                "customerMobile": "+27 73 675 7529",
                "customerWork": "0860074333",
                "customerIdentity": "7910175258089",
                "identityType": 1,
                "employerName": "Sieff Optometrists Incorporated",
                "employerAddress": "186 Elston avenue\nwestern extension\nBonni\n1501",
                "branchName": "Sieff Optometrists, Head Office",
                "branchAddress": "Isle of Houghton\n36 Boundary Road\n202 Old Trafford 1, 2nd Floor\n2193"
            }
        }
    ]
}

export const mockVendorResponse: Vendor[] = [
    {
        "id": 3066,
        "name": "DANIELA OPTICA",
        "tradingName": "DANIELA OPTICA",
        "registrationNumber": "",
        "telephone": "011-452-0086",
        "address": "SHOP G10 NORTHMEAD SQUARE\nC/R O''RELLY MERRY & 14TH AVE\nNORTHMEAD\n1501",
        "postalCode": "1501",
        "email": "spilklor@mweb.co.za",
        "administrationFee": 35,
        "initiationFee": 145,
        "agents": [
            {
                "id": 1,
                "agentId": 4709,
                "firstName": "Aharon David",
                "lastName": "Lis",
                "telephone": "086555555",
                "email": "aharon@enationnetworks.co.za"
            },
            // {
            //     "id": -2,
            //     "agentId": -4709,
            //     "firstName": "Keagan",
            //     "lastName": "Fouche",
            //     "telephone": "0797302588",
            //     "email": "Keaganfouche@gmail.com"
            // }
        ],
        "resources": [
            {
                "id": 1,
                "resourceId": 728737,
                "name": "Customer Optifin Signature 147692",
                "size": 9699,
                "extension": ".png",
                "contentType": "image/jpeg",
                "contentUrl": "https://optimalblobstorage.blob.core.windows.net/resources/e0d12dbf-db57-46ad-9c73-ac909243ef26.png",
                "resourceType": 15
            }
        ]
    }
];

export const mockVendorApplication: SingleResponse<CustomerApplicationProduct[]> = {
    total: 1,
    result: [
        {
            // API to fetch Patients for application on request.
            "id": 1, // Use on /customerProductPatient/list/{id}
            "auxiliaryAmount": null, // Medical aid, not required
            "baseAmount": 1692.0,
            "baseInstalment": 211.5,
            "clinicId": null, // Medical aid, not required
            "customerId": 7604,
            "customerProductMandateId": null,
            "excludeConsolidate": false, // not required
            "individualBankAccountId": 4747,
            "individualEmploymentId": 4575,
            "instalments": 8,
            "organisationBankAccountId": null, // not required
            "organisationEmploymentId": null, // not required
            "overrideDate": null, // maybe?
            "overrideInstalmentAmount": null, // maybe?
            "preLegal": false,
            "productId": 3,
            "productStatusId": 9,
            "reference": "OP815347",
            "startDate": "2008-04-27T00:00:00",
            "customerProductEmployment": {
                "id": 1,
                "employerName": "Checkers",
                "branchName": "Checkers Hyper, Bloemfontein",
                "employerId": 4575,
                "employerAdress": "",
                "branchAddress": "Fleurdal Mall\nVereeniging drive, Fleurdal\nBLOEMFONTEIN\n9301",
                "employmentStatus": "Verified",
                "payCycle": "Monthly",
                "paymentFrequencyId": 7,
                "payday": 25,
                "dateStart": "1992-04-27T00:00:00",
                "dateEnd": null,
                "employerNumber": "6508049",
                "designation": "Front End Counter"
            },
            "customer": {
                "id": 7604,
                "consolidateDebitOrders": false,
                "contactMethod": 0,
                "individualId": 10308,
                "organisationId": null,
                "underReview": false,
                "customerInfo": {
                    "isIndividual": true,
                    "activeProduct": false,
                    "id": 7604,
                    "initials": "D.S.",
                    "customerName": "Dinnah Seipati Mathobisa",
                    "name": "Dinnah Seipati",
                    "lastName": "Mathobisa",
                    "customerAddress": "3889 Segotlihelo St.\nBochabela\n0",
                    "customerEmail": null,
                    "customerHome": null,
                    "customerMobile": "0732099384",
                    "customerWork": null,
                    "customerTitle": null,
                    "customerIdentity": "5709080720080",
                    "identityType": 1,
                    "employerName": "Checkers",
                    "employerAddress": "",
                    "branchName": "Checkers Hyper, Bloemfontein",
                    "branchAddress": "Fleurdal Mall\nVereeniging drive, Fleurdal\nBLOEMFONTEIN\n9301"
                }
            },
            // "customerProductOverride": {
            //     "id": 1,
            //     "interestRate": 0.0,
            //     "arrearsInterest": false,
            //     "annualIncrease": 0.0,
            //     "penalty": 0.0
            // },
            "customerProductBankAccount": {
                "id": 1,
                "isActive": true,
                "isDeleted": false,
                "accountNumber": "627655572",
                "bankId": 29,
                "bank": "Standard Bank",
                "branchId": null,
                "branch": "",
                "branchCode": "051001",
                "bankAccountStatus": 4,
                "bankAccountType": 1,
                "accountHolder": "Dinnah Seipati Mathobisa",
                "bankAccountId": 4747
            },
            "customerProductValue": {
                "amountLastMoneyReceived": 766.67,
                "arrears": 0.0,
                "balance": 3978.33,
                "collected": 766.67,
                "countOfRejectedPayments": 0,
                "dateLastMoneyReceived": new Date("2025-05-20T15:01:11.76Z"),
                "entityState": 16,
                "id": 161833,
                "interestAccrued": 0.0,
                "isActive": true,
                "isDeleted": false,
                "keep": true,
                "keepReference": null,
                "lastDateCL": new Date("2025-05-20T13:01:11.863Z"),
                "lastDateIL": new Date("2025-05-20T13:01:11.863Z"),
                "lastDebitOrderDate": new Date("2025-05-18T22:00:00Z"),
                "lastDebitOrderErrorAmount": 0.0,
                "lastDebitOrderErrorCode": null,
                "lastDebitOrderErrorDate": null,
                "lastDebitOrderErrorDescription": null,
                "runningBalance": 3978.33,
                "surchargeTotal": 0.0,
            }
        }
    ]
}

export const mockCustomerLoginResponse = {
    "access_token": "FAKE_TOKEN",
    "token_type": "bearer",
    "expires_in": 431999,
    "refresh_token": "37832",
    "as:client_id": "optimal-vendor",
    "userName": "vendor_customer",
    "isAdmin": "false",
    "isTaskManager": "false",
    "isInteraction": "true",
    "isMarketing": "false",
    "pin": "0",
    "email": "",
    "mobile": "",
    ".issued": "Wed, 21 Aug 2024 14:59:19 GMT",
    ".expires": "Mon, 26 Aug 2024 14:59:19 GMT",
    "applicationId": 129
};